export const AUTH_TOKEN = "5487_>vkjdfo0&9df8lpoug.Kikloju>fjs(*)";